<template>
  <div class="view pa24">
    <el-input class="w220" v-model="keyWord" :placeholder="$t('article', 'articleTitle')" />

    <el-date-picker
      class="ml20"
      v-model="pickerValue"
      align="right"
      type="daterange"
      :start-placeholder="$t('marketing', 'startDate')"
      :end-placeholder="$t('marketing', 'endDate')"
      :picker-options="pickerOptions"
    />
    <el-button class="ml10" type="primary" @click="getDynamicInfo"
      >{{ $t('marketing', 'search') }}</el-button
    >
    <commonTable
      :tableData="tableData"
      :loading="loading"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
      :currentPage="currentPage"
      :total="total"
    >
      <template v-slot:table>
        <el-table-column type="index" align="center" :label="$t('common', 'serialNumber')" />
        <el-table-column prop="title" align="center" :label="$t('article', 'articleTitle')" />
        <el-table-column prop="originAuthor" align="center" :label="$t('article', 'author')">
          <template slot-scope="scope">
            {{ scope.row.originAuthor ? scope.row.originAuthor : "——" }}
          </template>
        </el-table-column>
        <el-table-column prop="createTime" align="center" :label="$t('article', 'publishDate')"
          ><template slot-scope="scope">
            {{ setDataTimeSec(scope.row.createTime) }}
          </template>
        </el-table-column>
        <el-table-column prop="shareNum" align="center" :label="$t('article', 'shareCount')" />
        <el-table-column prop="readNum" align="center" :label="$t('article', 'readCount')" />
        <el-table-column align="center" prop="readTime" :label="$t('article', 'readTime')">
        </el-table-column>
        <el-table-column prop="nickeName" align="center" :label="$t('article', 'author')" />
        <el-table-column prop="isDrafts" align="center" :label="$t('article', 'articleStatus')">
          <template slot-scope="scope">
            <el-switch
              :value="scope.row.isDrafts == 1 ? false : true"
              @change="(e) => switchChange(e, scope.row.dynamicId)"
              :active-text="$t('article', 'publish')"
              :inactive-text="$t('article', 'close')"
            >
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column align="center" :label="$t('common', 'edit')" width="150">
          <template slot-scope="scope">
            <el-button class="mr10" type="text" @click="edit(scope.row)"
              >{{ $t('common', 'edit') }}</el-button
            >
            <customPopconfirm
              :confirm-button-text="$t('common', 'confirm')"
              :cancel-button-text="$t('common', 'cancel')"
              @confirm="del(scope.row.dynamicId)"
              icon="el-icon-info"
              icon-color="red"
              :title="$t('common', 'confirm') + $t('article', 'confirmDeleteArticle')" >
              <el-button slot="reference" style="color: #fd634e" type="text"
                  >{{ $t('common', 'delete') }}</el-button
                >
            </customPopconfirm>
          </template>
        </el-table-column>
      </template>
    </commonTable>
    <el-dialog
      :title="$t('article', 'addActivity')"
      :visible.sync="centerDialogVisible"
      :modal-append-to-body="false"
      :destroy-on-close="true"
      width="50%"
      center
    >
      <postArticles @submitForm="submitForm" ref="postArticles" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">{{ $t('common', 'cancel') }}</el-button>
        <el-button type="primary" @click="determine(0)">{{ $t('common', 'confirm') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import commonTable from "@/components/common/commonTable";
import customPopconfirm from "@/components/common/customPopconfirm";
import postArticles from "./components/postArticles";
import { getDataTimeSec } from "@/utils";
import {
  getDynamicInfo,
  updateDynamicState,
  addDynamicInfo,
  delDynamicInfo,
} from "@/api/articleManagement";
import i18nMixin from '@/mixins/i18nMixin';
export default {
  mixins: [i18nMixin],
  data() {
    return {
      tableData: [],
      currentPage: 1, //当前页
      pageSize: 10, //显示条数
      loading: false, //表格加载
      total: 0, //总条数
      keyWord: "",
      essayTypeId: "",
      pickerValue: "",
      centerDialogVisible: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
    };
  },
  components: {
    commonTable,
    postArticles,
    customPopconfirm
  },
  computed: {
    setDataTimeSec() {
      return (data) => getDataTimeSec(data);
    },
  },
  created() {
    this.getDynamicInfo();
  },
  methods: {
    determine(data) {
      
      this.$refs.postArticles.submitForm(data);
    },
    /**
     * @method 发布文章提交
     * @param {Object} val - 表单值
     */
    async submitForm(val) {
      let data = {
        isDrafts: val.isDrafts ? 0 : 1,
        ...val,
      };
      try {
        await addDynamicInfo(data, { showLoading: true });
        this.centerDialogVisible = false;
        await this.getDynamicInfo();
      } catch (error) {
        console.log(error);
      }
    },
    
    async getDynamicInfo() {
      let data = {
        pageSize: this.pageSize,
        pageNum: this.currentPage,
        essayTypeId: this.essayTypeId,
        isDrafts: 1,
        title: this.keyWord,
        startTime:
          this.pickerValue == "" ? "" : `${this.pickerValue[0]} 00:00:00`,
        endTime:
          this.pickerValue == "" ? "" : `${this.pickerValue[1]} 23:59:59`,
      };
      try {
        this.loading = true;
        const result = await getDynamicInfo(data);
        this.loading = false;
        const {
          pageInfo: { total, list },
        } = result?.data;
        this.tableData = list;
        this.total = total;
      } catch (error) {
        console.log(error);
        this.tableData = [];
      }
    },
    handleSizeChange(val) {
      this.pageSize = val;
    },
    handleCurrentChange(val) {
      this.currentPage = val;
    },
    edit(val) {
      this.centerDialogVisible = true;
      const {
        dynamicId,
        companyId,
        title,
        photos,
        details,
        originAuthor,
        createUserId,
        createTime,
        isDel,
        isDrafts,
      } = val;
      let data = {
        dynamicId,
        companyId,
        title,
        photos,
        details,
        originAuthor,
        createUserId,
        createTime,
        isDel,
        isDrafts:isDrafts ? true : false,
      }
     this.$nextTick(() => {
        this.$refs.postArticles.ruleForm = data;
        this.$refs.postArticles.fileList.push({name:'',url:photos})
     })
    },
    async switchChange(e, id) {
      let data = {
        dynamicId: id,
        isDrafts: e ? 0 : 1,
      };
      await updateDynamicState(data);
      this.getDynamicInfo();
    },
    /**@method 删除
     * @param {String} val - 文章id
     */
    async del(val) {
      try {
        await delDynamicInfo({ dynamicId: val });
        await this.getDynamicInfo();
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>